module.exports = __webpack_public_path__ + "static/img/play_circle.a0666bd7.png";